export default "__VITE_ASSET__BeP3b_qL__"